import React from "react";

import {
    Users
} from "lucide-react";


const UsersPage = () => {

    return (
        <div className="page-container">

            <div className="page-header">

                <div>

                    <h2>
                        Users
                    </h2>

                    <p>
                        ERP system users
                    </p>

                </div>

            </div>


            <div className="content-card">

                <div className="empty-state">

                    <Users size={40} />

                    <h3>
                        User Management
                    </h3>

                    <p>
                        User authentication and
                        role management will be
                        connected here.
                    </p>

                </div>

            </div>

        </div>
    );
};


export default UsersPage;